import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { fetchLeaves } from "@/services/api/leave";
import type { IUserLeave } from "@/services/api/leave";
import { handleResponse } from "@/services/axios";

interface LeaveState {
  userLeaves: IUserLeave[];
  loading: boolean;
  error: string | null;
  filters: {
    month: number;
    year: number;
  };
}

const initialState: LeaveState = {
  userLeaves: [],
  loading: false,
  error: null,
  filters: {
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  },
};

export const getLeaves = createAsyncThunk(
  "leave/getLeaves",
  async ({ fromDate, toDate }: { fromDate: string; toDate: string }, { rejectWithValue }) => {
    try {
      const data = await fetchLeaves(fromDate, toDate);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.Message || "Failed to fetch leaves");
    }
  }
);

const leaveSlice = createSlice({
  name: "leave",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<{ month: number; year: number }>) => {
      state.filters = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLeaves.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLeaves.fulfilled, (state, action) => {
        state.loading = false;
        state.userLeaves = action.payload;
      })
      .addCase(getLeaves.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setFilters } = leaveSlice.actions;
export default leaveSlice.reducer;
